import { faqAccordion } from './components/faqs';

(function ($) {

	const updateHeight = () => {
		let slide = main.Components.Slides.getAt(typeof (newIndex) == 'number' ? newIndex : main.index).slide;
		slide.parentElement.parentElement.style.height = slide.offsetHeight + 'px';
	};

	const main = new Splide('#product---image', {
		type: 'fade',
		pagination: false,
		arrows: false,
		cover: true,
		autoHeight: true,
	}).on('move resized', updateHeight);

	const nav = document.getElementById('product--image_nav');
	if (nav) {
		const thumbnails = new Splide('#product--image_nav', {
			isNavigation: true,
			gap: "1rem",
			pagination: false,
			autoWidth: true,
			updateOnMove: true
		});

		main.sync(thumbnails);
		main.mount();
		thumbnails.mount();
	} else {
		main.mount();
	}

	updateHeight();

	faqAccordion('.product--faq-wrap', '.products--faq-question');

	new Splide('.products.related .splide', {
		type: 'slide',
		pagination: false,
		arrows: true,
		perPage: 4,
		perMove: 1,
		rewind: true,
		breakpoints: {
			1200: {
				perPage: 3,
			},
			768: {
				perPage: 2,
			},
			400: {
				perPage: 1,
			}
		}
	}).mount();

}(jQuery))

